import { newToolFilterOAuthMcp } from "../oauth.ts";

export const rampMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://ramp.com/apple-touch-icon.png",
  // Ramp's docs name this host; the older ramp-mcp-remote.ramp.com host
  // fronts the same OAuth app (DCR returns the same client).
  url: "https://mcp.ramp.com/mcp",
  label: "Ramp",
});
